import { css } from "styled-components";
export const brandVerticalGradient = css `
      linear-gradient(180.81deg, #27367B -0.48%, #28377C 42.18%, #1445B8 80.83%,
      #1c3d97 90.96%)
`;
export default brandVerticalGradient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJhbmRWZXJ0aWNhbEdyYWRpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21peGlucy9icmFuZFZlcnRpY2FsR3JhZGllbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBRXhDLE1BQU0sQ0FBQyxNQUFNLHFCQUFxQixHQUFHLEdBQUcsQ0FBQTs7O0NBR3ZDLENBQUM7QUFFRixlQUFlLHFCQUFxQixDQUFDIn0=